import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
Vue.use(VueRouter);

//import HelloWorld from './components/HelloWorld.vue'

/*import Home from "./components/dashboard/Home";
import Login from "./components/Login/Login";
*/
//import Page from "./components/Login/Login";

//Masters
/*
import Vendor from "./components/Masters/Vendors";
import Commodities from "./components/Masters/Commodities";
import VendorMaster from "./components/Masters/VendorMaster";
import VendorCommodities from "./components/Masters/VendorCommodities";
import Users from "./components/Masters/Users";
import UploadPrices from "./components/Masters/UploadPrices";

*/
//import UserEdit from "./components/Masters/UserEdit";
//import Page from "./components/Masters/page";

//Upload Prices

//request

import store from "./store";

import NotFound from "./components/Error/NotFound";

var CryptoJS = require("crypto-js");
var exist = false;

const ifAuthenticated = async (to, from, next) => {
  
  var authenticate = store.getters.authencticate;
  if (!authenticate) {
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    if (ca) {
      var e_token = "uid=";
      
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        if (ca[i]) {
          c = c.toString().trim();
          if (c.indexOf(e_token) == 0) {
            e_token = c.substring(e_token.length, c.length);
            //exist = true;
            break;
          }
        }
      }
      
      if(e_token != null || e_token != "uid=" || e_token != ""){
        
        await store.dispatch("LOGIN_TOKEN_REQUEST", e_token)
            .then((res) => {
              var { data } = res;
              var Ukey = "";
              var CID = "";
              var token = "";
              if (data && data.StatusCode == 200) {
                Ukey = data.ResponseData.uniqueKey;
                CID = data.ResponseData.clientId;
                token = data.ResponseData.token;

                //decrypt token with key and compare with token
                
                var d_token = CryptoJS.AES.decrypt(e_token, Ukey).toString(CryptoJS.enc.Utf8);
                if(d_token == token)
                {
                  //create client id again and encrypt with key -> compare client ids
                  var captchacode = localStorage.getItem('_grecaptcha');
                  var nav_info = window.navigator;
                  var screen = window.screen;
                  var cltId = captchacode + ";" + nav_info.userAgent + ";" + nav_info.platform + ";" + nav_info.deviceMemory + ";" + nav_info.hardwareConcurrency;
                  cltId += ";" + screen.height + ";" + screen.width + ";" + screen.pixelDepth;
                  cltId += ";" + screen.availHeight + ";" + screen.availWidth;
                  var d_CID = CryptoJS.AES.decrypt(CID, Ukey).toString(CryptoJS.enc.Utf8);

                  if(d_CID == cltId)
                  {
                    var d = new Date();
                    d.setTime(d.getTime() + 24 * 60 * 60 * 1000); // two hrs
                    var expires = "expires=" + d.toGMTString();
                    var s = process.env.NODE_ENV == "development" ? "" : "secure;";

                    document.cookie =
                    "univ_id=" +
                    Ukey +
                    ";" +
                    expires +
                    ";path=/" +
                    ";samesite=strict;" +
                    (s == "" ? "" : s);
                    exist = true; 
                  }
                }
              } 
            })
            .catch((err) => {
              console.log(err);
            });
      }
    }
  }
  
  AuthenticatLoginToken(to, from, next);
};

const AuthenticatLoginToken = (to, from, next) => {
  
  if (exist) {
      store.dispatch("LOAD_REQUEST");
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  if (!store.getters.TOKEN) {
    next({
      path: "/login",
      query: {
        redirect: to.fullPath,
      },
    });
  } else {
    next();
  }
};

const routes = [{
    path: "/",
    component: () => import("@/components/dashboard/Home"), // Home,
    meta: {
      layout: "default",
      redirect: "/Requests",
      link: "requests",
      id: "Request",
      title: "Buy Request"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/Users",
    alias: "/Masters-Users",
    component: () => import("@/components/Masters/Users"), // Users,
    meta: {
      layout: "default",
      link: "masters",
      id: "Users",
      title: "Users"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/Commodities",
    alias: "/Masters-Commodities",
    component: () => import("@/components/Masters/Commodities"), // Commodities,
    meta: {
      layout: "default",
      link: "masters",
      id: "Commodity",
      title: "Commodities"
    },
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: "/Vendors",
  //   // alias: "/Masters-Vendors",
  //   component: VendorMaster,
  //   meta: {
  //     layout: "default",
  //     link: "masters",
  //     id: "Vendors"
  //   },
  //   beforeEnter: ifAuthenticated
  // },

  {
    path: "/vendor/",
    component: () => import("@/components/Masters/VendorMaster"), // VendorMaster,
    children: [{
        path: "vendors",
        component: () => import("@/components/Masters/Vendors"), // Vendor,
        meta: {
          layout: "default",
          link: "masters",
          ActiveLink: "/vendor/vendors",
          id: "Vendors",
          title: "Vendors"
        }
      },
      {
        path: "VendorCommodities/:id",
        component: () => import("@/components/Masters/VendorCommodities"), // VendorCommodities,
        meta: {
          layout: "default",
          link: "masters",
          ActiveLink: "/vendor/vendors",
          id: "Vendors",
          title: "Vendor Commodities"
        }
      }
    ],
    meta: {
      layout: "default",
      link: "masters",
      id: "Vendors",
      title: "Vendors"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/BankCommodities",
    component: () => import("@/components/Masters/BankCommodities"),
    meta: {
      layout: "default",
      link: "masters",
      id: "bankCommodities",
      title: "Bank Commodities"
    },
    beforeEnter: ifAuthenticated
  },

  //requests

  {
    path: "/Requests",
    component: () => import("@/components/Requests/Requests"),
    meta: {
      layout: "default",
      link: "requests",
      id: "Request",
      title: "Buy Request"
    },
    beforeEnter: ifAuthenticated
  },

  {
    path: "/SellRequest",
    component: () => import("@/components/Requests/SellRequests"),
    meta: {
      layout: "default",
      link: "requests",
      id: "sellRequest",
      title: "Sell Request"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/CompletedRequest",
    component: () => import("@/components/Requests/CompletedRequest"),
    meta: {
      layout: "default",
      link: "requests",
      id: "Completed",
      title: "Completed Request"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/MIS",
    component: () => import("@/components/Requests/MIS"),
    meta: {
      layout: "default",
      link: "mis",
      id: "mis",
      title: "MIS"
    },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/UplaodPrices",
    component: () => import("@/components/Masters/UploadPrices"), // UploadPrices,
    beforeEnter: ifAuthenticated,
    meta: {
      layout: "default",
      link: "uploadprice",
      id: "UploadPrice",
      title: "Upload-Prices"
    }
  },
  // {
  //   path: "/Commitions",
  //   component: () => import("@/components/Masters/Commissions"), // UploadPrices,
  //   beforeEnter: ifAuthenticated,
  //   meta: {
  //     layout: "default",
  //     link: "commission", // Menu.commission on default layout
  //     id: "commision",
  //     title: "Commitions"
  //   }
  // },
  {
    path: "/Login",
    component: () => import("@/components/Login/Login"),
    meta: {
      layout: "login",
      title: "Login",
      content: "Login"
    }
  },
  {
    path: "/ForgotPassword",
    component: () => import("@/components/Login/ForgotPassword"),
    meta: {
      layout: "login",
      title: "Forgot-Password",
      content: "Login"
    }
  },
  {
    path: "/ChangePassword/:key",
    component: () => import("@/components/Login/ChangePassword"),
    meta: {
      layout: "login",
      title: "Login-Change Password",
      content: "Login"
    }
  },
  {
    path: "/ResetPassword/:ResetToken",
    component: () => import("@/components/Login/ResetPassword"),
    meta: {
      layout: "login",
      title: "Reset-Password",
      content: "Login"
    }
  },
  {
    path: "*",
    component: () => import("@/components/Error/NotFound"), //NotFound,
    meta: {
      layout: "error",
      class: "errorClass"
    }
  }
];

const router = new VueRouter({
  routes, // short for `routes: routes`,
  mode: "history",
  // base: "/GFH/"
  base: "/"
  //base: "/APP/"
});

router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.title) {
    document.title = "Alinma - " + to.meta.title;
  }

  next();
});
export default router;

export const ISLOCAL = true;